import { render, staticRenderFns } from "./ProductModel.vue?vue&type=template&id=45a9bd66&scoped=true"
import script from "./ProductModel.vue?vue&type=script&lang=js"
export * from "./ProductModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a9bd66",
  null
  
)

export default component.exports